var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDegitalMarketingSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 481.03 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#d6d8e5;}.cls-1{opacity:0.4;}.cls-2{fill:#b1b4c4;}.cls-4{fill:#9ea1af;}.cls-5{fill:#c4c7d6;}.cls-6{fill:#e4e7f2;}.cls-7{fill:#fff;}.cls-8{fill:#ffcea9;}.cls-9{fill:#ededed;}.cls-10{fill:#38226d;}.cls-11{fill:#9c73ff;}.cls-12{fill:#6dc77a;}.cls-13{fill:#f4f4f4;}.cls-14{fill:#3a2c6d;}.cls-15{fill:#fca70d;}.cls-16{fill:#e9eaf2;}.cls-17{fill:#e28c10;}.cls-18{fill:#ef990f;}.cls-19{fill:#7c5522;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Degital_marketing_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_1-2",
    "data-name": "\\u0421\\u043B\\u043E\\u0439 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "monitor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297,395.44l-60-34.65c-4.33-2.5-3.78-6.86,1.21-9.75l38.89-22.45,75.69,43.7L313.9,394.74C308.9,397.63,301.34,397.94,297,395.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M301.4,392.87l-60-34.66c-4.32-2.5-3.78-6.86,1.22-9.75L281.47,326l75.69,43.7-38.88,22.46C313.28,395.05,305.72,395.36,301.4,392.87Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "357.17 369.71 357.17 367.42 353.67 369.44 357.17 369.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "238.45 354.08 238.45 351.75 242.04 353.24 238.45 354.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M301.4,390.57l-60-34.65c-4.32-2.5-3.78-6.86,1.22-9.75l38.88-22.45,75.69,43.7-38.88,22.45C313.28,392.76,305.72,393.07,301.4,390.57Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "281.67 323.82 272.31 292.74 348.83 336.63 357.17 367.42 281.67 323.82"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M355,368.7l2.21-1.28-3.29-2.63Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "279.26 324.99 269.89 293.91 346.42 337.8 354.95 368.7 279.26 324.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M473.51,421.08l-296.2-171c-4.15-2.4-7.52-8.84-7.52-14.38V6.59c0-5.54,3.37-8.09,7.52-5.69l296.2,171c4.15,2.4,7.52,8.83,7.52,14.37V415.4C481,420.94,477.66,423.48,473.51,421.08Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "475.03 423.45 478.31 421.55 476.89 411.82 475.03 423.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M169.26,2.31,172.49.45l4.64,2.65s-4.94.75-5.06.72S169.26,2.31,169.26,2.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M470.79,422.65l-296.19-171c-4.16-2.39-7.52-8.83-7.52-14.37V8.16c0-5.54,3.36-8.09,7.52-5.69l296.19,171c4.16,2.4,7.52,8.83,7.52,14.37V417C478.31,422.5,475,425.05,470.79,422.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M470.27,423l-296.19-171c-4.16-2.4-7.53-8.83-7.53-14.37V8.46c0-5.54,3.37-8.09,7.53-5.69l296.19,171c4.15,2.39,7.52,8.83,7.52,14.37V417.26C477.79,422.8,474.42,425.35,470.27,423Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M473.72,409,170.32,233.85l.15-224.48c0-2.29,1.62-3.23,3.61-2.08l296.19,171a8,8,0,0,1,3.6,6.24Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 381.1,
    cy: 481.26,
    rx: 23.29,
    ry: 13.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 104.02,
    cy: 486.56,
    rx: 23.29,
    ry: 13.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 23.29,
    cy: 364.59,
    rx: 23.29,
    ry: 13.44
  }), /*#__PURE__*/React.createElement("g", {
    id: "Men_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M87.7,396.64s.66,9.88,2,11.29,5.67,2.4,5.67,2.4l3.38,5.55S95.62,398.22,95,397.8,87.7,396.64,87.7,396.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-9",
    d: "M94.19,385.67a3.69,3.69,0,0,0-4.7,1.42c-1.24,2.06-2.53,9.11-2.65,10.32,0,0,1.74,2.41,4.36,2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M104.19,484.24a7.28,7.28,0,0,0,5.46-.66c1.32,0,8.46-3,9.43-.45.85,2.25-2.24,4.33-3.89,4.73-3.61.87-6.28,2.67-7.73,3-1.08.22-2.48.37-3.34-.48C103.09,489.35,103.18,485.58,104.19,484.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M107.46,490.21c1.45-.3,4.12-2.1,7.73-3,1.38-.33,3.77-1.85,4-3.65.32,2.07-2.47,3.9-4,4.28-3.61.87-6.28,2.67-7.73,3-1.08.22-2.48.37-3.34-.48a2.06,2.06,0,0,1-.47-.86A4.32,4.32,0,0,0,107.46,490.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M93.07,480.77a7.23,7.23,0,0,0,5.46-.66c1.31,0,8.46-3,9.43-.45.85,2.25-2.24,4.33-3.9,4.73-3.6.87-6.27,2.67-7.72,3-1.08.23-2.48.37-3.34-.47C92,485.88,92.06,482.11,93.07,480.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M96.34,486.74c1.45-.3,4.12-2.1,7.72-3,1.39-.34,3.77-1.86,4-3.66.32,2.07-2.47,3.91-4,4.28-3.6.87-6.27,2.67-7.72,3-1.08.23-2.48.37-3.34-.47a2.05,2.05,0,0,1-.47-.87A4.29,4.29,0,0,0,96.34,486.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M92.28,460.68a43.92,43.92,0,0,1,1.64-7.82s-.49-6.75-.73-13.15c-.28-7.27-2.8-13.66-.81-19.46l22.12,4.92s-1.07,29-1.37,32.53a64.59,64.59,0,0,1-1,8.13C111.1,471.46,110,484,110,484c-2.37,1.37-5.84.24-5.84.24s0-15.75.13-19.8c.19-5,.34-4.57.34-4.57l-.74-12.32-.48-6.13s-.63,4.5-1,8.52c-.35,3.5-1.2,6.67-2.14,13.19-.82,5.66-1.67,17.19-1.67,17.19-2.37,1.38-5.56.43-5.56.43S91.63,465.59,92.28,460.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M95.38,385.79c1.7.09,3,.53,3.19,0a21.32,21.32,0,0,0,.39-2.66c-.2-.5-.37-1-.37-1-2.14-1.32-2.82-3.64-3.1-6.34-.48-4.61,2-8.64,6.62-9.12,4.33-.46,7.52,2.59,8.38,6.77.45,2.07,1.37,6,.13,9.37-.69,1.9-1.58,3.41-2.46,3.7a21.27,21.27,0,0,1-2.57-.23h0l-.38,2.1c-.16.82-.1,1.26,1.54,2.26s-2.48,3.08-5.17,2.88-5.7-1.82-6.53-3.56C94.12,388,94.21,385.74,95.38,385.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M97.85,386.05c-.48,1.18.72,2.62,3.93,3.63s3.5-.29,3.5-.29a64,64,0,0,1,6.23,3.21c1.92,1.34,2.77,5.23,3,11.81.3,7.6.33,18.88.08,20.83,0,0-3.6,3.58-8.2,3.2S94.08,424,92.2,420.85c0-6.67.83-7.75-.25-11.6-2.47-8.79-3.77-12.39-2.57-18.23,1-4.82,2.37-5.42,4.28-5.37A40,40,0,0,1,97.85,386.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M110.57,431.09l-2.34-26.48,4.94-2.62,1.92,1.62-.59,23.78h0l0,.65h0l0,.84s.11,2-3.66,4.39c0,0-.06-.63-.12-1.21h0l-.09-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_5",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-9",
    d: "M110,391c2.55,0,4.17,1.3,4.8,5.23s1,7.14,1,7.14a6.84,6.84,0,0,1-4.54,2.25c-3.09.35-4-1.22-4-1.22s-.33-4.08-.5-6.85S106.83,391,110,391Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M110.34,372.82s4-6.05-4.65-7.29c-6.23-.89-10.23,3.11-10.69,7.45-.44,4.15,2.11,8.46,4,10.17a7.54,7.54,0,0,0,5.38-.65,32.23,32.23,0,0,0,.12-3.4S101.42,372.71,110.34,372.82Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M445,367.55,205.66,229.37c-4.93-2.84-8.93-10.48-8.93-17.06V36.09c0-6.58,4-9.6,8.93-6.75L445,167.51c4.93,2.85,8.93,10.49,8.93,17.06V360.8C453.92,367.37,449.92,370.4,445,367.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M431.58,342.8,192.26,204.63c-4.94-2.85-8.93-10.49-8.93-17.07V11.34c0-6.58,4-9.6,8.93-6.75L431.58,142.76c4.93,2.85,8.93,10.49,8.93,17.07V336.05C440.51,342.63,436.51,345.65,431.58,342.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M440.51,173.7,183.33,25.21V11.34c0-6.58,4-9.6,8.93-6.75L431.58,142.76c4.93,2.85,8.93,10.49,8.93,17.07Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 198.95,
    cy: 22.38,
    rx: 2.55,
    ry: 4.42,
    transform: "translate(15.47 102.48) rotate(-30)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 223.07,
    cy: 36.3,
    rx: 2.55,
    ry: 4.42,
    transform: "matrix(0.87, -0.5, 0.5, 0.87, 11.74, 116.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 211.01,
    cy: 29.34,
    rx: 2.55,
    ry: 4.42,
    transform: "translate(13.6 109.44) rotate(-30)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "219.94 193.8 207.44 186.58 207.44 135.03 219.94 142.24 219.94 193.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "266.38 220.61 253.87 213.39 253.87 125.75 266.38 132.97 266.38 220.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "243.16 207.21 230.66 199.99 230.66 130.9 243.16 138.12 243.16 207.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "289.59 234.01 277.09 226.8 277.09 105.13 289.59 112.34 289.59 234.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "418.19 201.02 319.06 143.79 319.06 129.36 418.19 186.59 418.19 201.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "418.19 219.58 319.06 162.35 319.06 155.13 418.19 212.36 418.19 219.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "418.19 233.33 319.06 176.1 319.06 168.88 418.19 226.11 418.19 233.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "404.79 239.34 319.06 189.85 319.06 182.63 404.79 232.13 404.79 239.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "392.29 245.88 319.06 203.6 319.06 196.38 392.29 238.66 392.29 245.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "361.04 257.73 330.67 240.2 330.67 232.99 361.04 250.51 361.04 257.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "327.99 238.66 319.06 233.5 319.06 226.28 327.99 231.44 327.99 238.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "361.04 275.26 330.67 257.73 330.67 250.51 361.04 268.04 361.04 275.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "327.99 256.19 319.06 251.03 319.06 243.81 327.99 248.97 327.99 256.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "415.51 289.18 385.15 271.65 385.15 264.44 415.51 281.96 415.51 289.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "382.47 270.11 373.54 264.95 373.54 257.73 382.47 262.89 382.47 270.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "415.51 306.71 385.15 289.18 385.15 281.96 415.51 299.49 415.51 306.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "382.47 287.63 373.54 282.48 373.54 275.26 382.47 280.42 382.47 287.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "162.43 352.59 76.02 302.33 84.49 296.52 170.89 346.78 162.43 352.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M167.12,345.12,94.79,303.36c-4.94-2.85-8.93-10.49-8.93-17.06V169.88c0-6.58,4-9.6,8.93-6.75l72.33,41.76c4.93,2.85,8.93,10.49,8.93,17.06V338.37C176.05,345,172.05,348,167.12,345.12Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "167.61 348.79 173.18 345.45 167.56 336.62 167.61 348.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "84.3 165.5 89.37 162.44 89.19 170.6 84.3 165.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162,348.22,89.63,306.45C84.7,303.61,80.7,296,80.7,289.39V173c0-6.57,4-9.6,8.93-6.75L162,208c4.93,2.85,8.93,10.49,8.93,17.07V341.46C170.89,348,166.89,351.06,162,348.22Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "157.5 238.4 94.09 201.79 94.09 183.24 157.5 219.84 157.5 238.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "111.95 249.23 94.99 239.43 94.99 220.87 111.95 230.67 111.95 249.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "134.28 262.12 117.31 252.32 117.31 233.76 134.28 243.56 134.28 262.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "156.6 275 139.64 265.21 139.64 246.65 156.6 256.44 156.6 275"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "111.95 277.07 94.99 267.27 94.99 248.71 111.95 258.51 111.95 277.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "134.28 289.96 117.31 280.16 117.31 261.6 134.28 271.4 134.28 289.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "156.6 302.85 139.64 293.05 139.64 274.49 156.6 284.29 156.6 302.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "111.95 304.91 94.99 295.11 94.99 276.55 111.95 286.35 111.95 304.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "134.28 317.8 117.31 308 117.31 289.44 134.28 299.24 134.28 317.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "156.6 330.69 139.64 320.89 139.64 302.33 156.6 312.13 156.6 330.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "415.43 466.69 380.79 446.69 388.87 442.03 423.51 462.03 415.43 466.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "427.29 460.03 391.57 439.4 396.04 398.68 422.83 414.14 427.29 460.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "418.01 465.18 382.29 444.56 386.76 403.83 413.55 419.3 418.01 465.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-18",
    points: "418.01 465.18 427.29 460.03 422.83 414.14 413.55 419.3 418.01 465.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "386.76 403.83 396.04 398.68 394.95 408.56 386.76 403.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M406.84,415.34l-1.65-1c0-3.84-2.26-8.28-5-9.88s-5,.22-5,4.06l-1.65-.95c0-4.9,3-7.15,6.69-5S406.84,410.44,406.84,415.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M415.55,410l-1.65-.95c0-3.85-2.26-8.28-5-9.88s-5,.21-5,4.06l-1.65-.95c0-4.9,3-7.15,6.69-5S415.55,405.12,415.55,410Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Girl_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_6",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M395.31,380.29c2,.57,3.1,2.76,4.83,7.43a38.82,38.82,0,0,1,2.08,13.16c-.55,4.4-2.37,7.82-6.78,11.39l-2.1-3.85s4.31-3.81,4.75-8.21c.25-2.47-2.65-10.8-2.65-11S395.31,380.29,395.31,380.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M378.06,481.72a4.81,4.81,0,0,1-4-.54c-1.08,0-7.4-2.47-8.2-.37-.69,1.84,1.84,3.54,3.19,3.87,2.95.72,5.14,2.19,6.33,2.44a3,3,0,0,0,2.73-.39C379,485.9,378.89,482.82,378.06,481.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M375.39,486.61c-1.19-.25-3.38-1.72-6.33-2.44-1.13-.27-3.09-1.51-3.28-3-.27,1.69,2,3.2,3.28,3.5,2.95.72,5.14,2.19,6.33,2.44a3,3,0,0,0,2.73-.39,1.78,1.78,0,0,0,.39-.7A3.54,3.54,0,0,1,375.39,486.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M394.12,473.37a3.79,3.79,0,0,1-3.47-.52c-1,0-7.5-2.38-8.27-.35-.67,1.77,1.77,3.41,3.07,3.72,2.84.69,4.95,2.11,6.09,2.35a2.88,2.88,0,0,0,2.63-.37C395,477.4,394.91,474.43,394.12,473.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M391.54,478.08c-1.14-.24-3.25-1.66-6.09-2.35-1.09-.26-3-1.46-3.16-2.88-.25,1.63,1.95,3.08,3.16,3.37,2.84.69,4.95,2.11,6.09,2.35a2.88,2.88,0,0,0,2.63-.37,1.63,1.63,0,0,0,.37-.68A3.4,3.4,0,0,1,391.54,478.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_7",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M396.24,457.33a20.94,20.94,0,0,0-1.24-7.12s.83-9.75,1.45-16.15c.91-9.44,2.36-10.37,1.95-16.1-.38-5.32-3.4-8.77-4.19-12.37l-15.41,1.22s-1.34,4.36-3.07,13.06-1.84,19.05-1.68,32.76c.05,3.53-.6,6.6-.39,15.4.14,5.92.47,13.16.47,13.16,2.26,1.94,3.82.51,3.82.51s3.95-17.52,4.53-21.55a12.62,12.62,0,0,0-.54-6.65s1.16-5.51,2-9.84c1.05-5.28,3.63-16.69,3.63-16.69s-.44,17.53.33,21,.9,6.46,1.55,11.16c.79,5.69,1.15,14,1.15,14,2.35,1.49,3.39.34,3.39.34S396.24,462.3,396.24,457.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M394.21,405.59c1.61,1.65,4.28,6.68,4.28,14.29,0,8.56-1.25,6.82-1.84,16.26l-.6,9.43s-12.87,6.14-22.05.44c-.82-1.78.31-21.61,1.91-28.66s2.73-10.51,2.73-10.51S390.48,410,394.21,405.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_8",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M394.39,380.2c-3.28-.19-3.59.35-3.86-.81-.09-.42-.27-3.31-.27-3.31a10.28,10.28,0,0,0,.82-1.21,8.4,8.4,0,0,0-3.53-15.52c-4.36-.46-7.56,2.6-8.41,6.8-.46,2.07-.94,6.31.35,9.7.73,1.92,1.4,3.27,3.14,3.2a10.39,10.39,0,0,0,1.71-.3,16,16,0,0,1,.1,2.4c-.05.84.1,1.27-1.55,2.28s2.49,3.09,5.18,2.89,5.73-1.84,6.57-3.58C395.56,380.79,395.94,380.3,394.39,380.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M396.81,394.75s3.71-.84,5.41-2.49c0,0-2.21-6.95-3.62-8.7s-2.78,9.48-2.78,9.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_9",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M391.14,380.13c.6.76.67,1.71-1.67,2.3a7.42,7.42,0,0,1-5.13-.39,33.79,33.79,0,0,0-5.3,2.81c-2,6.57-.38,7.41-1.22,12.12.32,2.37.72,8.48.82,9.87,4.46,3.12,13.53,2.06,15.57-1.25a25.38,25.38,0,0,1,.31-3.3c2.13-7.9,3.8-10,3.2-16-.34-3.41-.6-5.12-2.41-6A16,16,0,0,0,391.14,380.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_10",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M350.09,405.84a25.12,25.12,0,0,1,3,.86,9.88,9.88,0,0,0,2.91,1c1.1.18,2.81-.39,5.77-1.79a31.88,31.88,0,0,0,8.66-6.51,75.92,75.92,0,0,0,7.57-10.8c1.28-2.34,2.91-2.93,4.32-2.47,1.69.56,1.9,2.23,0,5.39a59.85,59.85,0,0,1-8.66,11.34,32.42,32.42,0,0,1-9,6.37,28.11,28.11,0,0,1-7.6,2.64c-.93.2-1.56.58-3.27,1.18a11.24,11.24,0,0,1-5.32.59c-1.49-.29-2-.63-2.06-1s.25-.62.94-.57a9.31,9.31,0,0,0,3.3-.08s-1.52-.05-2.44-.16a9.08,9.08,0,0,1-2.36-.6c-.73-.31-1-1.45-.27-1.41s1.24.25,2.59.39a9,9,0,0,0,2.16,0,17.31,17.31,0,0,1-2.64-.65,3.79,3.79,0,0,1-1.84-1.13c-.25-.29-.18-1,.68-.83a13.69,13.69,0,0,0,3.23.72c1.11,0,1.89-.09,1.75-.27s-.79-.14-1.64-.62-1.32-1.37-1-1.8S349.19,405.51,350.09,405.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M380.53,395.31a12,12,0,0,1-6.81-3.45l4.12-5.72s2.32-2.93,5.38-1.27c0,0,2.32.25,0,5.08A50.68,50.68,0,0,1,380.53,395.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M378.34,363.67a3.82,3.82,0,0,1,4.31-3.14,7.2,7.2,0,0,1,4.9-1.18c3.91.4,6.47,2.94,7.66,6.86a31.71,31.71,0,0,1,1.15,6c1.18,8.71,4.34,15.63,1.38,18.21s-11.06,4.23-14.44,2.58,2.79-16.64-3.92-25C377.81,366.05,377.66,364.66,378.34,363.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Men_13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M11,360.45c1.53,1.24,3.78.11,3.89.22a68.24,68.24,0,0,0,5.63,4.69c1,.75,2.43,1.75,2.16,3.18-.48,2.57-4.59,1.78-6.14,1s-2.82-2.09-4.29-3c-1-.65-2.08-1-2.24-2.31C9.86,363.42,10.68,360.42,11,360.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M10,363.69c.2,1.27,1.22,1.62,2.26,2.26,1.49.93,2.8,2.27,4.35,3.05s5,1.45,6-.39c-.54,2.48-4.59,1.7-6.12.93s-2.82-2.09-4.29-3c-1-.65-2.08-1-2.24-2.31A2,2,0,0,1,10,363.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M24.19,355.53c1.52,1.24,4.19-.12,4.31,0a60,60,0,0,0,5,4.54c.95.75,2.44,1.75,2.17,3.18-.48,2.57-4.6,1.78-6.15,1s-2.82-2.09-4.29-3c-1-.65-2.08-1-2.24-2.31C22.91,358.14,23.92,355.5,24.19,355.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M23.06,358.58c.2,1.27,1.22,1.62,2.26,2.27,1.49.92,2.8,2.26,4.35,3s5,1.44,6-.39c-.54,2.48-4.59,1.7-6.12.92s-2.82-2.09-4.29-3c-1.05-.65-2.08-1-2.24-2.31A2.06,2.06,0,0,1,23.06,358.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_11",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-12",
    d: "M10.86,304.15c.08,2.31.8,12.32,1.12,17.62s.39,11.8.39,11.8-.91,3.87-1.51,8.41,0,18.87,0,18.87a3.64,3.64,0,0,0,3.91,0s2.44-11.47,3.57-16.64,1.33-8.14,1.91-11.35c.71-3.87,2.24-21.95,2.24-21.95l.62,0,1.63,20.41a22.83,22.83,0,0,0-1,4.64c-.44,3.32.47,20.05.47,20.05a4.06,4.06,0,0,0,4.22-.17s4.08-22.16,4.08-25.53c0-2.23-.39-31.63-.39-31.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_12",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M16.39,259.57s.26,5,.15,5.47-2.31,1.92-2.95,2.45,3.48,4.59,5.48,5.51,8.34-1.5,8.46-4.62-1.09-5.73-2.06-5.87S16.39,259.57,16.39,259.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.17,268.9c.29-2.22-1.17-4.32.25-6.09,5,4.87,4.33,17.74,5.46,26,3.68,3.86,11.09,7.65,13.17,8.59.38.18.71.36.64.77A9.28,9.28,0,0,1,48,301.92c-4.9-2.12-8.43-3.33-14.56-9.15a13.64,13.64,0,0,1-1.55-2C30.1,285.48,29.66,272.73,30.17,268.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_13",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-13",
    d: "M15.83,265.91s3.65,5.44,8.74,5.95c1.61-1.58,1.75-7.21-.47-9,0,0,2-1.65,3.44-1.33a7.2,7.2,0,0,1,3.14,4,33,33,0,0,1,1.8,11.64c-.09,5.34,0,21.64,0,21.64s-.72,3.45-5.32,6-8,2.82-11.15,2.09c-2.58-.6-4.71-1.51-5.6-3.38.23-3.74,1.9-13.5,1.28-18.2s-1.62-8.21-1.88-12,.5-3.72,2.41-5.08A31,31,0,0,1,15.83,265.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_14",
    "data-name": "<\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440>",
    className: "cls-8",
    d: "M27.77,252.07h0c-.6-3.9-3.41-6.86-7.43-6.64a7.74,7.74,0,0,0-3.95,14.14,7.74,7.74,0,0,0,.63,1.71c1.42,1.66,5.73,2.69,7,2.51a3.69,3.69,0,0,0,3.21-2.62C28.52,258.1,28.1,254,27.77,252.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M16.39,259.57h0l.37-3.41S14,249,20.55,250.34c4.34.92,5.43,1.31,6.75-1.6s-3.33-5.53-8.86-4.8a7.64,7.64,0,0,0-6.85,7.75C11.74,253.83,12.31,258.17,16.39,259.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M8.69,271.07c1.91-.54.46-.09,1.91-.54,5,4.86,4.34,13.21,5.47,21.45C18.81,296.51,29,302.65,29,302.65c.13.87-.18,1.13-1.28,2.91a44,44,0,0,1-15.13-9.76c-.24-.23-.59-.29-.69-.6C10.13,289.94,8.19,274.9,8.69,271.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "53.95 281.23 46.55 306.5 30.34 312.98 36.25 288.36 53.95 281.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M26.42,302.83c.24-.86.87-.65,1.57-.43a4.2,4.2,0,0,0,2.4.21,7.37,7.37,0,0,0,1.72-1.17,2.15,2.15,0,0,1,1.08-.3c0,.21-.37,1.5-.37,1.5s3.55,0,3.92,0a.6.6,0,0,1,.56,1l.24,0c.73-.17,1,.95.31,1.12l-.6.09c.48.18.6,1,0,1.08l-.19,0a.59.59,0,0,1-.26,0h-.11a.64.64,0,0,1-.53.76c-1.74.22-4.29.91-5.86-.52a9.75,9.75,0,0,1-3.15-.85C26.16,304.83,26.13,303.86,26.42,302.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M44.17,300.76h.24a.6.6,0,0,1,.34-1.09c.37,0,4-.76,4-.76l.44-1.5c0-.09.63.3.65.31A2.49,2.49,0,0,1,51,299.54a4,4,0,0,1-1,2.83,3.66,3.66,0,0,1-2.48,1.07l-1.26.08a.63.63,0,0,1-.68-.62H45.4a.61.61,0,0,1-.26,0H45c-.62,0-.67-.78-.25-1.06-.2,0-.4,0-.6,0C43.36,301.92,43.42,300.76,44.17,300.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M32.23,272.2A3.93,3.93,0,0,0,34.88,271c-.14-1.87-2.53-9-7.34-9.49a8.89,8.89,0,0,1,3,3.63A47.27,47.27,0,0,1,32.23,272.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M7.83,281.57s4.78,1.65,8.15-1.12c.37-.64-2-8.78-2-8.78s-2-4.17-5.15-2.51S7.83,281.57,7.83,281.57Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDegitalMarketingSvg);
export default __webpack_public_path__ + "static/media/Degital_marketing_SVG.9ccedddfef4f5809fa324246ddfb5713.svg";
export { ForwardRef as ReactComponent };